define('editor/edit/map/mapstate',['durandal/app'], function (app) {
    var mapstate = function(mapControl) {
        var self = this;

        self.map = mapControl;

        self.getmapBounds = function() {
            var bounds = self.map.getBounds();

            //console.log({
            //    zoom: self.map.getZoom(),
            //    swlat: bounds.getSouthWest().wrap().lat,
            //    swlon: bounds.getSouthWest().wrap().lng,
            //    nelat: bounds.getNorthEast().wrap().lat,
            //    nelon: bounds.getNorthEast().wrap().lng
            //});

            //Full world view so reutrn a correct box
            if (Math.abs(bounds.getSouthWest().lng - bounds.getNorthEast().wrap().lng) > 360) {
                return {
                    zoom: self.map.getZoom(),
                    swlat: -90,
                    swlon: -180,
                    nelat: 90,
                    nelon: 180
                };
            }

            return {
                zoom: self.map.getZoom(),
                swlat: bounds.getSouthWest().wrap().lat,
                swlon: bounds.getSouthWest().wrap().lng,
                nelat: bounds.getNorthEast().wrap().lat,
                nelon: bounds.getNorthEast().wrap().lng
            };
        };
        
        self.removeLayers = function(layers) {
            for (var i = 0; i < layers.length; i++) {
                self.map.removeLayer(layers[i]);
            }
        };
    };

    return mapstate;
});

